
import ProductChangelog from "@/types/ProductChangelog";
import PaginationType from "@/types/Pagination";
import { computed, defineComponent, PropType } from "vue";
import Changelog from "@/Components/Product/Changelog.vue";
import Pagination from "../General/Pagination.vue";
import { useForm } from "@inertiajs/inertia-vue3";

export default defineComponent({
  props: {
    changelogs: {
      type: Object as PropType<PaginationType<ProductChangelog>>,
      required: true,
    },
    field: {
      type: String,
      default: () => "all",
    },
  },
  setup(props) {
    const changelogsData = computed(() => props.changelogs.data);

    const filterForm = useForm({
      field: props.field,
    });

    const filterResults = () => {
      filterForm.get(location.href);
    };

    return {
      filterForm,
      filterResults,
      changelogsData,
    };
  },
  components: { Changelog, Pagination },
});
